import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function HowAnOemProgramWorks() {
  return <section id="how-an-oem-program-works" className="bg-card-foreground text-secondary py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-4xl">
        <h2 className="text-3xl md:text-4xl font-bold font-default mb-8 text-secondary">
          How Does an Evermark OEM Program Work?
        </h2>

        <div className="space-y-6 mb-10">
          <p className="text-lg font-default leading-relaxed">
            An OEM program turns marking into a predictable supply line. Evermark
            Industrial Solutions approves a first article with you, then locks
            the layout, material, fonts, and serialization logic. Every
            subsequent release produces to that approved standard — no
            re-proofing from scratch, no format drift between runs.
          </p>

          <p className="text-lg font-default leading-relaxed">Reorders run against your production cadence. Evermark Industrial Solutions produces to release schedules and quantities you set, marks variable data (serials, models, dates) from a supplied sequence or list, and keeps the approved program on file for the life of the product. Program structure, release/reorder process, minimums, and onboarding:.</p>
        </div>

        <div className="border-l-4 border-primary pl-6 py-4 mb-10 bg-background/5 rounded-r-lg">
          <h3 className="text-xl font-bold font-default mb-3 text-secondary">
            Private-label and branded nameplates
          </h3>
          <p className="font-default leading-relaxed">
            Evermark Industrial Solutions produces nameplates carrying the OEM's
            branding and product identity for application to the OEM's own
            equipment.{" "}
            
            .
          </p>
        </div>

        <div>
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 font-bold text-base px-8">
            <Link to="/ContactPage">Work with Evermark</Link>
          </Button>
        </div>
      </div>
    </section>;
}